import axios from 'axios';
import {constance} from '../../common/constance/constance';

class ImageData {
	constructor(dataUrl, type) {
		this.dataUrl = dataUrl;
		this.type = type;
	}
	
	/* minify the image
	 */
	minify(options = {}) {
		return new Promise((resolve, reject) => {
			const maxWidth = options.maxWidth || 800;
			const maxHeight = options.maxHeight || 800;
			const quality = options.quality || 0.8;
			if (!this.dataUrl) {
				return reject({
					message:
						'[error] QuillImageDropAndPaste: Fail to minify the image, dataUrl should not be empty.',
				});
			}
			const image = new Image();
			image.onload = () => {
				const width = image.width;
				const height = image.height;
				if (width > height) {
					if (width > maxWidth) {
						image.height = (height * maxWidth) / width;
						image.width = maxWidth;
					}
				} else {
					if (height > maxHeight) {
						image.width = (width * maxHeight) / height;
						image.height = maxHeight;
					}
				}
				const canvas = document.createElement('canvas');
				canvas.width = image.width;
				canvas.height = image.height;
				var ctx = canvas.getContext('2d');
				ctx.drawImage(image, 0, 0, image.width, image.height);
				const canvasType = this.type || 'image/png';
				const canvasDataUrl = canvas.toDataURL(canvasType, quality);
				resolve(new ImageData(canvasDataUrl, canvasType));
			};
			image.src = this.dataUrl;
		});
	}
	
	/* convert blob to file
	 */
	toFile(filename) {
		if (!window.File) {
			console.error(
				'[error] QuillImageDropAndPaste: Your browser does not support File API.',
			);
			return null;
		}
		return new File([this.toBlob()], filename, {type: this.type});
	}
	
	/* convert dataURL to blob
	 */
	toBlob() {
		const base64 = this.dataUrl.replace(/^[^,]+,/, '');
		const buff = this.binaryStringToArrayBuffer(atob(base64));
		return this.createBlob([buff], {type: this.type});
	}
	
	/* generate array buffer from binary string
	 */
	binaryStringToArrayBuffer(binary) {
		const len = binary.length;
		const buffer = new ArrayBuffer(len);
		const arr = new Uint8Array(buffer);
		let i = -1;
		while (++i < len) arr[i] = binary.charCodeAt(i);
		return buffer;
	}
	
	/* create blob
	 */
	createBlob(parts = [], properties = {}) {
		if (typeof properties === 'string') properties = {type: properties};
		try {
			return new Blob(parts, properties);
		} catch (e) {
		}
	}
}

class ImageDropAndPaste {
	constructor(quill, options = {}) {
		this.quill = quill;
		this.options = options;
		this.handleDropToServer = this.handleDropToServer.bind(this);
		this.handlePasteToServer = this.handlePasteToServer.bind(this);
		this.quill.root.addEventListener('drop', this.handleDropToServer, false);
		this.quill.root.addEventListener('paste', this.handlePasteToServer, false);
	}
	
	/* handle image drop event
	 */
	
	handleDropToServer(e) {
		if (!e.dataTransfer || !e.dataTransfer.files || !e.dataTransfer.files.length) return;
		const file = e.dataTransfer.files[0];
		if (!file.type || !/^(image|video)\//.test(file.type)) return;
		e.preventDefault();
		e.stopImmediatePropagation();
		if (document.caretRangeFromPoint) {
			const selection = document.getSelection();
			const range = document.caretRangeFromPoint(e.clientX, e.clientY);
			if (selection && range) {
				selection.setBaseAndExtent(
					range.startContainer,
					range.startOffset,
					range.startContainer,
					range.startOffset,
				);
			}
		}

		this.saveImageToServer(file);
	}
	
	saveImageToServer(file) {
		const formData = new FormData();
		let url = '';
		// 파일이 input 태그에 담기면 실행 될 함수
		formData.append('files', file);
		
		// 저의 경우 파일 이미지를 서버에 저장했기 때문에
		// 백엔드 개발자분과 통신을 통해 이미지를 저장하고 불러왔습니다.
		try {
			
			axios({
				method: 'post',
				url: constance.api.imageUploadUrl,
				data: formData,
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}).then(value => {
				console.log(value);
				if (value.data.success) {
					url = value.data.url;
					let type = url.split('.')[1];
					if (type === 'mp4' || type == 'ogg' || type == 'webm') {
						this.insert.call(this, url, 'video');
					} else {
						this.insert.call(this, url, 'image');
					}
					
				}
			}).catch(reason => {
				console.log(reason);
			});
		} catch (error) {
		}
	}
	
	handleDrop(e) {
		e.preventDefault();
		if (e.dataTransfer && e.dataTransfer.files && e.dataTransfer.files.length) {
			if (document.caretRangeFromPoint) {
				const selection = document.getSelection();
				const range = document.caretRangeFromPoint(e.clientX, e.clientY);
				if (selection && range) {
					selection.setBaseAndExtent(
						range.startContainer,
						range.startOffset,
						range.startContainer,
						range.startOffset,
					);
				}
			}
			console.log('this1', this);
			
			this.readFiles(e.dataTransfer.files, (dataUrl, type) => {
					type = type || 'image/png';
					if (typeof this.options.handler === 'function') {
						const result = this.options.handler.call(
							this,
							dataUrl,
							type,
							new ImageData(dataUrl, type),
							newDataUrl => {
								console.log('Callback...');
								console.log(dataUrl.length);
								console.log(newDataUrl.length);
								console.log('this3', this);
								
								this.insert.call(this, newDataUrl, type);
							},
						);
						console.log(result);
					} else {
						console.log('this2', this);
						this.insert.call(this, dataUrl, type);
					}
				},
				e,
			);
		}
	}
	
	/* handle image paste event
	 */
	handlePasteToServer(e) {
		if (!e.clipboardData || !e.clipboardData.files || !e.clipboardData.files.length) return;
		const file = e.clipboardData.files[0];
		if (!file.type || !/^(image|video)\//.test(file.type)) return;
		e.preventDefault();
		e.stopImmediatePropagation();
		this.saveImageToServer(file);
	}
	
	/* handle image paste event
	 */
	handlePaste(e) {
		if (
			e.clipboardData &&
			e.clipboardData.items &&
			e.clipboardData.items.length
		) {
			this.readFiles(
				e.clipboardData.items,
				(dataUrl, type) => {
					type = type || 'image';
					if (typeof this.options.handler === 'function') {
						let file = this.dataURLtoFile(dataUrl, 'file.png');
						this.saveImageToServer(file);
						console.log(file);
						
						/*this.options.handler.call(
						 this,
						 dataUrl,
						 type,
						 new ImageData(dataUrl, type),
						 );*/
					} else {
						this.insert(dataUrl, type);
					}
				},
				e,
			);
		}
	}
	
	dataURLtoFile = (dataurl, fileName) => {
		
		var arr = dataurl.split(','),
			mime = arr[0].match(/:(.*?);/)[1],
			bstr = atob(arr[1]),
			n = bstr.length,
			u8arr = new Uint8Array(n);
		
		while (n--) {
			u8arr[n] = bstr.charCodeAt(n);
		}
		
		return new File([u8arr], fileName, {type: mime});
	};
	
	/* read the files
	 */
	readFiles(files, callback, e) {
		[].forEach.call(files, file => {
			var type = file.type;
			let isImage = type.match(/^image\/(gif|jpe?g|a?png|svg|webp|bmp)/i);
			let isVideo = type.match(/^video\/(mp4|webm|ogg)/i);
			if (!isImage && !isVideo) return;
			e.preventDefault();
			const reader = new FileReader();
			reader.onload = e => {
				callback(e.target.result, type);
			};
			const blob = file.getAsFile ? file.getAsFile() : file;
			if (blob instanceof Blob) reader.readAsDataURL(blob);
		});
	}
	
	/* insert into the editor
	 */
	insert(dataUrl, type) {
		let index = (this.quill.getSelection() || {}).index || this.quill.getLength();
		this.quill.insertEmbed(index, type, dataUrl, 'user');
		
		index = (this.quill.getSelection() || {}).index || this.quill.getLength();
		this.quill.insertText(index, '', '', true);
	}
}

ImageDropAndPaste.ImageData = ImageData;

export default ImageDropAndPaste;
